module.exports = __webpack_public_path__ + "static/media/s_pointer.6077b539.png";